const defaultApiUrl = "https://mitserver.app:2942";
const defaultSocketUrl = "https://mitserver.app:2942";

const getApiUrl = () => {
	return localStorage.getItem("externalApiUrl") || null;
};

const getSocketUrl = () => {
	return localStorage.getItem("externalApiUrl") || null;
};

module.exports = {
	apiUrl: defaultApiUrl,
	socketUrl: defaultSocketUrl,
	getApiUrl,
	getSocketUrl,
};
